import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { WizumenGuide } from '../wizumen-models';

@Component({
  selector: 'wizumen-guide',
  template: `
    <div class="wizumen-guide eva-3-card -eva-3-shadow-line">
        <span class="wizumen-guide-illustration"></span>
        <div class="wizumen-guide-text-content">
            <div class="wizumen-guide-detail">
                <em class="wizumen-guide-title -eva-3-bold">
                    {{WizumenGuide.title}}
                </em>
                <p class="wizumen-guide-text">
                    {{WizumenGuide.text}}
                </p>
            </div>
            <p class="wizumen-guide-link eva-3-link" (click)="handleGuideClick()">
                {{WizumenGuide.link_text}}
            </p>
        </div>
    </div>
  `,
  styleUrls: ['../wizumen.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenGuideComponent {
  @Input() WizumenGuide: WizumenGuide;
  @Input() wizumenGuideHref: string;
  @Input() toCityCode: string;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;

  constructor(private upaService: UpaService) {}

  handleGuideClick() {
    this.trackGuideClick();

    window.open(this.wizumenGuideHref, '_blank');
  }

  public trackGuideClick(): void {
    this.upaService.trackClickTopic({
        moduleId: this.moduleId,
        moduleIndex: this.moduleIndex,
        target: UpaTarget.WIZUMEN_MODAL,
        label: `guide-${this.toCityCode}`,
        href: this.wizumenGuideHref,
        dc: this.toCityCode,
        uniqueId: this.uniqueId
    })
  }
}